import { useSelector } from 'react-redux'
import { JACKPOT_RULES_TITLE } from '@constants/jackpotConstants'
import { formatJackpotRules } from '@core/jackpot/jackpotView'

// Static rules copy (no BE field for this, same as Tournaments' Rules tab).
const JackpotRulesTab = () => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const rules = formatJackpotRules(currencyCode)

  return (
    <div className="standard-normal-jackpot-rules-outer-container">
      <div className="standard-normal-jackpot-rules-title">{JACKPOT_RULES_TITLE}</div>
      <ul className="standard-normal-jackpot-rules-list no-scrollbar">
        {rules.map((rule, index) => (
          <li key={index} className="standard-normal-jackpot-rules-item">
            {rule}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default JackpotRulesTab
